module.exports = __webpack_public_path__ + "7a8b796a6fdb314fc9c54571223537fc.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BF.svg
// module id = 0NfW
// module chunks = 0